<template>
  <v-dialog v-model="showDlg" :max-width="maxWidth" persistent>
    <v-card>
      <v-card-title class="text-body-1 fMontserrat">
        <v-row>
          <v-col cols="1" v-if="icon">
            <v-icon class="mr-3" :color="color">{{ icon }}</v-icon>
          </v-col>
          <v-col :cols="icon ? 11 : 12" class="d-flex justify-center text-center fMontserrat">
            {{ title }}
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text v-if="message" class="text-subtitle-2 fMontserrat">
        <div class="text-center fMontserrat" v-html="message"></div>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <div v-if="!isConfirm">
          <v-btn :color="btnOKColor" text @click.stop.prevent="clickOK()">{{t('accept')}}</v-btn>
        </div>
        <div v-if="isConfirm">
          <v-btn :color="btnNOColor" text @click.stop.prevent="clickNO()">{{t('no')}}</v-btn>
          <v-btn :color="btnOKColor" text @click.stop.prevent="clickOK()">{{t('yes')}}</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, defineExpose } from "vue";
import { t } from "../functions/translation.js";

const showDlg = ref(false);
const color = ref(null);
const icon = ref(null);
const title = ref(null);
const message = ref(null);
const btnOKColor = ref(null);
const btnNOColor = ref(null);
const maxWidth = ref("350px");
const isConfirm = ref(false);
let resolve = null;
// eslint-disable-next-line no-unused-vars
let reject = null;
const alert = (data) => {
  if (!data) return;
  isConfirm.value = false;
  title.value = data.title || "";
  message.value = data.message;
  color.value = data.color || "success";
  btnOKColor.value = data.btnOKColor || "primary";
  icon.value = data.icon;
  maxWidth.value = data.maxWidth || "350px";
  showDlg.value = true;
  return new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
};
const confirm = (data) => {
  if (!data) return;
  isConfirm.value = true;
  title.value = data.title || "";
  message.value = data.message;
  color.value = data.color || "success";
  btnOKColor.value = data.btnOKColor || "primary";
  btnNOColor.value = data.btnNOColor || "red";
  icon.value = data.icon;
  maxWidth.value = data.maxWidth || "350px";
  showDlg.value = true;
  return new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
};

const clickOK = () => {
  showDlg.value = false;
  resolve(true);
};

const clickNO = () => {
  showDlg.value = false;
  resolve(false);
};

defineExpose({
  alert,
  confirm
})

</script>

<style>
.fMontserrat {
  font-family: Montserrat;
}
</style>
